module.exports = __webpack_public_path__ + "img/salesforce.8243e6b0.svg";